import { Component, Input } from '@angular/core';
import { map, tap } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./banner.service";
import * as i2 from "../snackbar";
import * as i3 from "@angular/common";
import * as i4 from "../icon-v2/icon.component";
import * as i5 from "../button-v2/button.component";
function BannerComponent_div_0_ng_container_1_div_1_geaui_button_v2_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 14);
    i0.ɵɵlistener("click", function BannerComponent_div_0_ng_container_1_div_1_geaui_button_v2_8_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const group_r2 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(group_r2.messages[0].data == null ? null : group_r2.messages[0].data.bannerButtonClicked());
    });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("inverted", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", group_r2.messages[0].data == null ? null : group_r2.messages[0].data.bannerButtonLabel, " ");
  }
}
function BannerComponent_div_0_ng_container_1_div_1_span_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16)(1, "geaui-icon-v2", 17);
    i0.ɵɵlistener("click", function BannerComponent_div_0_ng_container_1_div_1_span_9_Template_geaui_icon_v2_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const group_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clear(group_r2.messages[0].key));
    });
    i0.ɵɵelementEnd()();
  }
}
function BannerComponent_div_0_ng_container_1_div_1_span_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 18)(1, "geaui-icon-v2", 19);
    i0.ɵɵlistener("click", function BannerComponent_div_0_ng_container_1_div_1_span_10_Template_geaui_icon_v2_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const group_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.toggle(group_r2.severity));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("file", ctx_r3.isCollapsed[group_r2.severity] ? "24px_chevron-down" : "24px_chevron-up");
  }
}
function BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_geaui_button_v2_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 14);
    i0.ɵɵlistener("click", function BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_geaui_button_v2_6_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const msg_r7 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(msg_r7.data == null ? null : msg_r7.data.bannerButtonClicked());
    });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const msg_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("inverted", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", msg_r7.data == null ? null : msg_r7.data.bannerButtonLabel, " ");
  }
}
function BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_span_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16)(1, "geaui-icon-v2", 17);
    i0.ɵɵlistener("click", function BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_span_7_Template_geaui_icon_v2_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const msg_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r3.clear(msg_r7.key));
    });
    i0.ɵɵelementEnd()();
  }
}
function BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 6);
    i0.ɵɵelement(2, "geaui-icon-v2", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 9);
    i0.ɵɵtemplate(6, BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_geaui_button_v2_6_Template, 3, 2, "geaui-button-v2", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_span_7_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const msg_r7 = ctx.$implicit;
    const group_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("p-inline-message p-component p-inline-message-", group_r2.severity, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("file", ctx_r3.getFile(group_r2.severity));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", msg_r7.detail, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", msg_r7.data == null ? null : msg_r7.data.hasBannerButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", msg_r7.data == null ? null : msg_r7.data.hasCloseButton);
  }
}
function BannerComponent_div_0_ng_container_1_div_1_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, BannerComponent_div_0_ng_container_1_div_1_div_11_div_1_Template, 8, 7, "div", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r2.messages.slice(1));
  }
}
function BannerComponent_div_0_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div")(3, "span", 6);
    i0.ɵɵelement(4, "geaui-icon-v2", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 9);
    i0.ɵɵtemplate(8, BannerComponent_div_0_ng_container_1_div_1_geaui_button_v2_8_Template, 3, 2, "geaui-button-v2", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, BannerComponent_div_0_ng_container_1_div_1_span_9_Template, 2, 0, "span", 11)(10, BannerComponent_div_0_ng_container_1_div_1_span_10_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, BannerComponent_div_0_ng_container_1_div_1_div_11_Template, 2, 1, "div", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("p-inline-message p-component p-inline-message-", group_r2.severity, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("file", ctx_r3.getFile(group_r2.severity));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", group_r2.messages[0].detail, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", group_r2.messages[0].data == null ? null : group_r2.messages[0].data.hasBannerButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.messages[0].data == null ? null : group_r2.messages[0].data.hasCloseButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.messages.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.isCollapsed[group_r2.severity]);
  }
}
function BannerComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BannerComponent_div_0_ng_container_1_div_1_Template, 12, 9, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const group_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (group_r2.messages == null ? null : group_r2.messages.length) > 0);
  }
}
function BannerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, BannerComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const severityGroups_r9 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", severityGroups_r9);
  }
}
const FILES = new Map([['error', '16px_warning-sign'], ['warn', '24px_c-warning'], ['info', '16px_c-info']]);
export class BannerComponent {
  bannerService;
  snackbarService;
  groupedMessages$;
  isCollapsed = {
    error: true,
    warn: true,
    info: true
  };
  constructor(bannerService, snackbarService) {
    this.bannerService = bannerService;
    this.snackbarService = snackbarService;
    this.groupedMessages$ = this.bannerService.messages$.pipe(map(messages => this.removeSnackbarMessages(messages)), map(messages => this.buildSeverityGroups(messages)), tap(groups => {
      groups.forEach(group => {
        if (group.messages.length === 0) {
          this.isCollapsed[group.severity] = true;
        }
      });
    }));
  }
  removeSnackbarMessages(messages) {
    return messages.filter(msg => msg.key !== this.snackbarService.key);
  }
  buildSeverityGroups(messages) {
    const errors = messages.filter(m => m.severity === 'error');
    const warns = messages.filter(m => m.severity === 'warn');
    const infos = messages.filter(m => m.severity === 'info');
    return [{
      severity: 'error',
      messages: errors
    }, {
      severity: 'warn',
      messages: warns
    }, {
      severity: 'info',
      messages: infos
    }];
  }
  clear(key) {
    this.bannerService.clear(key);
  }
  getFile(severity) {
    return FILES.get(severity);
  }
  toggle(severity) {
    this.isCollapsed[severity] = !this.isCollapsed[severity];
  }
  static ɵfac = function BannerComponent_Factory(t) {
    return new (t || BannerComponent)(i0.ɵɵdirectiveInject(i1.BannerService), i0.ɵɵdirectiveInject(i2.SnackbarService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BannerComponent,
    selectors: [["geaui-banner"]],
    inputs: {
      isCollapsed: "isCollapsed"
    },
    decls: 2,
    vars: 3,
    consts: [["class", "gea-banner-container", 4, "ngIf"], [1, "gea-banner-container"], [4, "ngFor", "ngForOf"], ["class", "gea-banner", 4, "ngIf"], [1, "gea-banner"], [1, "gea-banner-wrapper"], [1, "gea-banner-icon-container"], ["color", "white", "colorProp", "stroke", 3, "file"], [1, "p-inline-message-text", "gea-font-body-16", "gea-font-white"], [1, "gea-banner-text-container"], ["type", "secondary", 3, "inverted", "click", 4, "ngIf"], ["class", "gea-banner-close-button", 4, "ngIf"], ["class", "gea-banner-toggle-button", 4, "ngIf"], ["class", "gea-banner-extra-messages", 4, "ngIf"], ["type", "secondary", 3, "click", "inverted"], [1, "gea-font-button-14", "gea-font-white"], [1, "gea-banner-close-button"], ["file", "24px_close", "color", "white", "colorProp", "stroke", 3, "click"], [1, "gea-banner-toggle-button"], ["color", "white", "colorProp", "stroke", 3, "click", "file"], [1, "gea-banner-extra-messages"], [3, "class", 4, "ngFor", "ngForOf"]],
    template: function BannerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, BannerComponent_div_0_Template, 2, 1, "div", 0);
        i0.ɵɵpipe(1, "async");
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.groupedMessages$));
      }
    },
    dependencies: [i3.NgForOf, i3.NgIf, i4.IconComponent, i5.ButtonV2Component, i3.AsyncPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-banner',
      template: "<div class=\"gea-banner-container\" *ngIf=\"groupedMessages$ | async as severityGroups\">\n  <ng-container *ngFor=\"let group of severityGroups\">\n    <div class=\"gea-banner\" *ngIf=\"group.messages?.length > 0\">\n      <div class=\"gea-banner-wrapper\">\n        <!-- Show the first message in that group (group.messages[0]) -->\n        <div class=\"p-inline-message p-component p-inline-message-{{ group.severity }}\">\n          <span class=\"gea-banner-icon-container\">\n            <geaui-icon-v2 [file]=\"getFile(group.severity)\" color=\"white\" colorProp=\"stroke\"></geaui-icon-v2>\n          </span>\n\n          <!-- The text of the first message -->\n          <span class=\"p-inline-message-text gea-font-body-16 gea-font-white\">\n            {{ group.messages[0].detail }}\n          </span>\n\n          <span class=\"gea-banner-text-container\">\n            <!-- Optional \"banner button\" for the first message -->\n            <geaui-button-v2\n              *ngIf=\"group.messages[0].data?.hasBannerButton\"\n              [inverted]=\"true\"\n              (click)=\"group.messages[0].data?.bannerButtonClicked()\"\n              type=\"secondary\">\n              <span class=\"gea-font-button-14 gea-font-white\">\n                {{ group.messages[0].data?.bannerButtonLabel }}\n              </span>\n            </geaui-button-v2>\n          </span>\n\n          <!-- Optional close button if hasCloseButton is set -->\n          <span class=\"gea-banner-close-button\" *ngIf=\"group.messages[0].data?.hasCloseButton\">\n            <geaui-icon-v2\n              (click)=\"clear(group.messages[0].key)\"\n              file=\"24px_close\"\n              color=\"white\"\n              colorProp=\"stroke\"></geaui-icon-v2>\n          </span>\n          <!-- If there's more than one message in that severity group, show a toggle -->\n          <span class=\"gea-banner-toggle-button\" *ngIf=\"group.messages.length > 1\">\n            <geaui-icon-v2\n              [file]=\"this.isCollapsed[group.severity] ? '24px_chevron-down' : '24px_chevron-up'\"\n              (click)=\"toggle(group.severity)\"\n              color=\"white\"\n              colorProp=\"stroke\"></geaui-icon-v2>\n          </span>\n        </div>\n\n        <!-- Show the rest of the messages if expanded -->\n        <div class=\"gea-banner-extra-messages\" *ngIf=\"!isCollapsed[group.severity]\">\n          <div\n            class=\"p-inline-message p-component p-inline-message-{{ group.severity }}\"\n            *ngFor=\"let msg of group.messages.slice(1)\">\n            <span class=\"gea-banner-icon-container\">\n              <geaui-icon-v2 [file]=\"getFile(group.severity)\" color=\"white\" colorProp=\"stroke\"></geaui-icon-v2>\n            </span>\n            <span class=\"p-inline-message-text gea-font-body-16 gea-font-white\">\n              {{ msg.detail }}\n            </span>\n\n            <span class=\"gea-banner-text-container\">\n              <geaui-button-v2\n                *ngIf=\"msg.data?.hasBannerButton\"\n                [inverted]=\"true\"\n                (click)=\"msg.data?.bannerButtonClicked()\"\n                type=\"secondary\">\n                <span class=\"gea-font-button-14 gea-font-white\">\n                  {{ msg.data?.bannerButtonLabel }}\n                </span>\n              </geaui-button-v2>\n            </span>\n\n            <span class=\"gea-banner-close-button\" *ngIf=\"msg.data?.hasCloseButton\">\n              <geaui-icon-v2 (click)=\"clear(msg.key)\" file=\"24px_close\" color=\"white\" colorProp=\"stroke\"></geaui-icon-v2>\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</div>\n"
    }]
  }], () => [{
    type: i1.BannerService
  }, {
    type: i2.SnackbarService
  }], {
    isCollapsed: [{
      type: Input
    }]
  });
})();
